import {siteConfig, copy} from '../site.js';
export function createCommerceClient(config) {
    return async function request(action, data = {}) {
        const response = await fetch(config.endpoint, {
            method: 'POST', credentials: 'same-origin',
            headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Novastars-Context': config.context || siteConfig().context || 'web', 'X-Checkout-Token': config.token},
            body: JSON.stringify({action, data})
        });
        const result = await response.json();
        if (!response.ok || !result.success) {
            const error = new Error(result.errors?.map(item => item.message).join(' ') || 'The checkout could not be updated.');
            error.result = result;
            throw error;
        }
        return result;
    };
}
